import React, {Component} from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {Link} from "react-router-dom";
import {Dropdown} from "semantic-ui-react";
import HomeIcon from '@material-ui/icons/Home';
import {CircularProgress, Snackbar} from "@material-ui/core";
import MySnackbarContentWrapper from "../components/Snackbar";
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import {Prompt} from "react-router";
import Typography from "@material-ui/core/Typography";
import {HelmetComponent} from "../components/Helmet";

class CaseTemplateEditFormScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            workflow: [],
            searchedWorkflow: [],
            setValue: false,
            isBlocking: false,

        };
        if (props.location.pathname.replace('/casetemplate/edit/', '').length > 0) {
            this.props.getCaseTemplateInfo(props.location.pathname.replace('/casetemplate/edit/', ''))
        }
    };

    componentDidMount() {
        this.props.fetchWorkflowList();
    }

    componentWillUnmount() {
        this.props.handleSnackBarClose();
        if(this.props.state.caseTemplateState.caseTemplateData.templateName !== '' ){
            this.props.setCaseTemplateData({
                templateName: '',
                workflow: [],
            })
        }
    }



    render() {
        const caseTemplateState = this.props.state.caseTemplateState;
        const createAddWorkFlowFormExistingWorkFlow = () => {
            var workFlows = [];
            var toFilter = caseTemplateState.caseTemplateData && caseTemplateState.caseTemplateData.workflow;
            caseTemplateState.caseTemplateData.workflow.map(single => {
                var alreadyChoosen = this.state.searchedWorkflow.filter(singleSearchedWorkFlow => singleSearchedWorkFlow.workflowId == single.workflowId)[0]
                var filtered = this.state.searchedWorkflow.filter(singleSearchedWorkFlow =>
                    !toFilter.find(singlePreSelectedWorkFlow => singlePreSelectedWorkFlow.workflowId === singleSearchedWorkFlow.workflowId)
                );
                console.log('alreadyChoosen',alreadyChoosen ? alreadyChoosen : "null" );
                filtered.push(alreadyChoosen ? alreadyChoosen : "");
                let formData = {
                    id: single.workflowId,
                    options: filtered,
                    value: {
                        workflowId: single.workflowId,
                        order:single.order
                    }
                };

                console.log('casetamplate', formData ? formData : console.log("hello"))
                workFlows.push(formData ? formData : "")
            })
            if (this.state.workflow.length != workFlows.length) {
                this.setState({
                    workflow: workFlows,
                    setValue: true
                });
            }

        };

        const createWorkFlowFormObject = () => {
            let formData = {
                id: String(Math.random()),
                options: this.state.searchedWorkflow.filter(
                    s => !this.state.workflow.find(a => s.value === a.value.workflowId)
                ),
                value: {
                    workflowId: '',
                    order: this.state.workflow.length + 1
                }
            };
            return formData
        };

        const showInputForField = () => {
            let a = createWorkFlowFormObject();
            this.setState({
                workflow: [...this.state.workflow, a]
            });
        };


        const changeWorkflowNameValue = (key, value) => {
            var perviousValue = this.state.workflow.filter(
                single => single.id == key
            )[0].value.workflowId;

            this.state.workflow.filter(
                single => single.id == key
            )[0].value.workflowId = value;

            var rest = this.state.workflow.filter(single => single.id != key);

            rest.map(single => {
                single.options = single.options.filter(s => s.value != value);
            });

            if (rest.length > 0 && perviousValue != "") {
                rest.map(single => {
                    single.options.push(
                        this.state.searchedWorkflow.filter(s => s.value == perviousValue)[0]
                    );
                });
            }
            filterWorkflowFormData();
        };

        const filterWorkflowFormData = () => {
            let workFlows = [];
            this.state.workflow.map(single => {
                return workFlows.push(single.value);
            });
            this.props.handleChangeCaseTemplate("workflow", workFlows);
        };

        const closeFieldSection = (key) => {
            //previous value
            var perviousValue = this.state.workflow.filter(
                single => single.id == key
            )[0].value.workflowId;
            var previousOrder = this.state.workflow.filter(
                single => single.id == key
            )[0].value.order;


            var rest = this.state.workflow.filter(single => single.id != key);
            if (rest.length > 0 && perviousValue != "") {
                rest.map(single => {
                    single.options.push(
                        this.state.searchedWorkflow.filter(s => s.value == perviousValue)[0]
                    );
                });
            }

            var removedActionData = this.state.workflow.filter(x => x.id != key)
            var lessThanOrder = removedActionData.filter(x => x.value.order < previousOrder)


           var orderFiltered =  removedActionData.filter(x => x.value.order > previousOrder)

           orderFiltered.map(single=> {
               single.value.order = single.value.order - 1
           })

           lessThanOrder = [...lessThanOrder, ...orderFiltered];

            this.setState(
                {
                    workflow: lessThanOrder
                },
                () => {
                    filterWorkflowFormData();
                }
            );
        };

        const openDropdownForWorkflow = () => {
            let div = [];
            // Outer loop to create parent
            this.state.workflow.map(single => {
                return (
                    div.push(<div  key={Math.random()}>
                        <div className="row">
                            <div className="col-10" style={{paddingRight: '30px'}}>
                                <Dropdown
                                    placeholder="Workflow"
                                    clearable
                                    fluid
                                    search
                                    selection
                                    selectOnBlur={false}
                                    id={single.id}
                                    value={single && single.value && single.value.workflowId}
                                    options={single.options}
                                    onChange={(e, data) => {
                                        e.preventDefault();
                                        this.setState({isBlocking: true});
                                        changeWorkflowNameValue(single.id, data.value);
                                    }}
                                    style={style.dropdownInput}
                                />
                            </div>
                            <div className="col-2" style={{paddingLeft: 0}}>
                                <RemoveCircleOutlineIcon
                                    style={{
                                        color: 'grey',
                                        width: '24px',
                                        height: '24px',
                                        marginTop: '2rem',
                                        cursor:'pointer'
                                    }}
                                    onClick={e => {
                                        e.preventDefault();
                                        this.setState({isBlocking: true});
                                        closeFieldSection(single.id);
                                    }}
                                />
                            </div>
                        </div>
                    </div>))
            });
            return div
        };


        return (
            <React.Fragment>
                <HelmetComponent title="Case Template"/>
                <Prompt
                    when={this.state.isBlocking}
                    message="Are you sure you want to leave this page?"
                />

                {this.props.state.caseTemplateState.loading ? (
                    <div
                        className={
                            this.props.state.caseTemplateState.loading ? "loader" : "loader hidden"
                        }
                        id="loader"
                    >
                        <CircularProgress style={{color: "#8BC83F"}}/>
                    </div>
                ) : null}

                <Breadcrumbs aria-label="breadcrumb" style={style.breadcrumb}>
                    <Link color="inherit" to="/dashboard" style={style.link}>
                        <HomeIcon style={{color: '#8BC83F', paddingBottom: '2px'}}/>Home
                    </Link>
                    <Link color="inherit" to="/casetemplate" style={style.link}>
                        Case Template
                    </Link>
                    <Typography color="inherit" className="link">
                        Edit Case Template
                    </Typography>
                </Breadcrumbs>

                <div style={style.container}>
                    {caseTemplateState &&
                    caseTemplateState.workflow &&
                    this.state.searchedWorkflow &&
                    caseTemplateState.workflow.length > 0 &&
                    this.state.searchedWorkflow.length !==
                    caseTemplateState.workflow.length ? this.setState({
                        searchedWorkflow: caseTemplateState.workflow.map(workflow => ({
                            workflowId: workflow.workflowId,
                            text: workflow.workflowName,
                            value: workflow.workflowId
                        }))
                    }) : null}
                    {this.state.setValue === false && caseTemplateState.caseTemplateData && caseTemplateState.caseTemplateData.workflow && this.state.searchedWorkflow.length > 0 && caseTemplateState.caseTemplateData.workflow.length > 0 ?
                        createAddWorkFlowFormExistingWorkFlow() : null}
                    <div className="row">
                        <div className="col-4" style={{paddingLeft: '0', paddingRight: '0', position: 'inherit'}}>
                            <label style={style.label}>Case Template Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="templateName"
                                // value={console.log("template",caseTemplateState)}
                                value={caseTemplateState.caseTemplateData ? caseTemplateState.caseTemplateData.templateName : null}
                                onChange={e => {
                                    this.setState({isBlocking: true});
                                    this.props.handleChangeCaseTemplate(e.target.id, e.target.value)
                                }
                                }
                                style={style.input}
                            />
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className="col-5"
                             style={{paddingLeft: '0', paddingRight: '0', position: 'inherit'}}>
                            {this.state.workflow.length > 0 ? openDropdownForWorkflow() : null}
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className="col-4"
                             style={{paddingLeft: '0', paddingRight: '0', position: 'inherit'}}>
                            <div style={{float: 'right', padding: '1.3rem 0 0 0', cursor:'pointer'}} onClick={(e) => {
                                e.preventDefault();
                                this.setState({isBlocking: true});
                                showInputForField();
                            }}>
                                <img src="/assets/images/add-button-inside-circle.svg" alt="Add Button"
                                     style={{width: '22px', height: '22px', cursor: 'pointer'}}/>
                                <span style={{fontSize: '14px', paddingLeft: '4px'}}>Add Workflow</span>
                            </div>
                            <div className={"row"}
                                 style={{
                                     justifyContent: 'flex-end',
                                     padding: '2rem 0 1rem 0',
                                     marginLeft: 0,
                                     width: '100%'
                                 }}>
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({isBlocking: false});
                                        this.props.editCaseTemplate(caseTemplateState.caseTemplateData, this.props);

                                    }}
                                    style={style.button}
                                >Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <Snackbar
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    open={this.props.state.caseTemplateState.openCaseTemplateSnackBar}
                    autoHideDuration={6000}
                    onClose={this.props.handleSnackBarClose}
                >
                    < MySnackbarContentWrapper
                        onClose={this.props.handleSnackBarClose}
                        variant="error"
                        message={this.props.state.caseTemplateState.errorMsgForCaseTemplate}
                    />
                </Snackbar>
            </React.Fragment>
        );
    }
}

const style = {
    container: {
        background: "#ffffff",
        marginTop: "78px",
        marginLeft: '3.5%',
        marginRight: '3.5%',
        height: '100%',
        // boxShadow: "rgba(0, 0, 0, 0) 0px 0px 1px 0px, rgba(0, 0, 0, 0.19) 0px 1px 4px 0px",
    },
    breadcrumb: {
        fontSize: "14px",
        borderBottom: "1px solid #dddddd",
        paddingTop: "12px",
        paddingBottom: "12px",
        paddingLeft: "2.5%",
        color: "#8BC83F",
        fontWeight: "bold",
        position: 'fixed',
        width: '100%',
        background: 'white',
        zIndex: 1
    },
    link: {
        color: '#8BC83F'
    },
    label: {
        color: '#606060',
        marginBottom: '0',
        fontSize: '16px',
        paddingBottom: "0.5rem"
    },
    input: {
        height: "40px",
        backgroundColor: "#F4F5F9",
        border: "none",
        width: '100%'
    },
    dropdownInput: {
        height: "40px",
        backgroundColor: "#F4F5F9",
        border: "none",
        width: '100%',
        fontSize: '15px',
        marginTop: '1.5rem',
        position: 'inherit'
    },
    header: {
        color: '#cc6600',
        fontSize: '22px',
        fontWeight: 'bolder',
        borderBottom: "1px solid #DEDEDE",
        paddingTop: "1rem",
        paddingBottom: '1rem',
        paddingLeft: '2rem'
    },
    selectedAction: {
        border: '1px solid #DCDCDC',
        padding: '1rem',
        boxShadow: "rgba(0, 0, 0, 0) 0px 0px 1px 0px, rgba(0, 0, 0, 0.19) 0px 1px 4px 0px",
        fontSize: '14px',
        marginBottom: '0.5rem',
        width: '80%'
    },
    button: {
        height: '35px',
        background: "#8BC83F",
        color: 'white',
        fontSize: '16px',
        border: 'none',
        borderRadius: '4px',
        width: '100px'
    }
};

export default CaseTemplateEditFormScreen;
